function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 310"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon awesome-telegram-plane",
    d: "m23.933 6.36-3.622 17.08c-.273 1.205-.986 1.505-2 .938l-5.518-4.066-2.663 2.561a1.386 1.386 0 0 1-1.109.541l.4-5.62 10.226-9.242c.445-.4-.1-.616-.691-.22L6.312 16.293.868 14.59c-1.184-.37-1.205-1.184.246-1.752l21.291-8.2c.987-.372 1.849.217 1.528 1.722z",
    transform: "translate(-.001 -2.592)",
    style: {
      fill: "#7a8b99"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.b0018b76c2913f7c37cac7e5757f2f31.svg";
export { ForwardRef as ReactComponent };